import React, { ReactElement } from 'react'

/* assets */
import { ReactComponent as CloseIcon } from 'public/assets/icons/close.svg'

interface Props {
  onClick: () => void
  title: string
}

function FilterChipButton({ title, onClick }: Props): ReactElement {
  return (
    <button
      className="flex items-center  |  bg-gray-10 text-gray-70  |  rounded  |  py-1.5 pl-3 pr-4  |  focus:outline-none focus:ring-2"
      onClick={onClick}
    >
      {title}
      <CloseIcon className="h-4 w-4  |  ml-2" />
    </button>
  )
}

export default FilterChipButton
